import uuid from "react-uuid";

const ENV = process.env.REACT_APP_NODE_ENV;
const BASE_URL_SSD = ENV === 'production' ? process.env.REACT_APP_BASE_URL_SSD : (ENV === 'staging' || ENV === 'development' ) ? process.env.REACT_APP_BASE_URL_SSD_STAGING : 'http://localhost:8080/api';

export const getFBAAPI = async (email) => {

  try {
    console.log('Fetching FBA for user ' + email + '...');

    const options = {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json',
        'email': email
      },
    };

    let result = await fetch(`${BASE_URL_SSD}/fba`, options);

    if (result.status === 200) {
      let fba = await result.json();
      return fba;
    } else {
      return null;
    };
  } catch (error) {
    console.error('Error fetching FBA!');
    console.error(error);
    return null;
  };
};
export const loadFBAAPI = async (location, email, keepId) => {

  try {
    console.log('Loading FBA from ' + location + '...');

    let result = await fetch(location);

    if (result.status === 200) {
      let fba = await result.json();
      let id;

      // if fba is created by another user, use a new id
      if (fba?.createdBy?.toLowerCase() !== email?.toLowerCase() && !keepId) {
        id = uuid();
      } else {
        id = fba?.id;
      };

      if (!fba?.public) {
        fba.createdBy = email;
      };

      return {...fba, id, location, lastModified: new Date()?.toDateString()};
    } else {
      return null;
    };
  } catch (error) {
    console.error('Error loading FBA!');
    console.error(error);
    return null;
  };
};

export const saveFBAAPI = async (fba) => {
  try {
    if (fba && fba?.id && fba?.createdBy && fba?.settings) {
      console.log('Saving FBA ' + fba?.name + ' to the database...');
      const newFba = {
        id: fba.id,
        name: fba.name || 'FBA',
        description: fba.description || '',
        color: fba.color || '',
        createdBy: fba.createdBy,
        lastModified: new Date(),
        location: fba.location,
        settings: fba.settings,
        public: fba.public,
        projectId: fba.projectId
      };
  
      const res = await fetch(`${BASE_URL_SSD}/fba`, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({fba: newFba})
      });
  
      if (res.status === 200) {
        console.log('FBA ' + fba?.name + ' saved to the database successfully');
        return { success: true };
      } else {
        console.log('Could not save FBA ' + fba?.name + '!');
        return { success: false };
      };
    } else {
      console.log('Please provide a valid FBA');
      return { success: false };
    };
    
  } catch (error) {
    console.log('Error saving FBA!');
    console.log(error);
    return { success: false };
  };
};

export const deleteFBAAPI = async (fbaId) => {
  try {
    if (fbaId && fbaId?.length > 0) {
      console.log('Deleting FBA ' + fbaId + '...');
  
      const res = await fetch(`${BASE_URL_SSD}/fba`, {
        method: 'DELETE',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': process.env.REACT_APP_API_KEY,
        },
        body: JSON.stringify({fbaId: fbaId})
      });
  
      if (res.status === 200) {
        console.log('FBA deleted ' + fbaId);
        return fbaId;
      } else {
        console.log('Could not delete FBA ' + fbaId + '!');
        return null;
      };
    };
    
  } catch (error) {
    console.log('Error deleting FBA!');
    console.log(error);
    return null;
  };
};
